import { RouteObject } from "react-router"
import { MeioPagList } from "./meiopg.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Payments } from "@mui/icons-material"

export enum PathRotaMeioPag {
    meioPag = "/meiopag"
}

const routerMeioPag: RouteObject = {
    path: PathRotaMeioPag.meioPag,
    element: <MeioPagList/>,
}


export const navigationToMeioPagView = ()=> rotas.navigate(PathRotaMeioPag.meioPag)

export function startRouterMeioPag(){
    const menu:MainMenu = {
        text:"Meios de Pagamento",
        icon:<Payments />,
        eventOnClick:navigationToMeioPagView
    }
    menuRotas.push(menu);
    return routerMeioPag
}